
import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import { I18n } from "aws-amplify/utils";

export const CustomAuthenticator = (props) => {

    const components = {
        Header: () => <div className='flex justify-content-center align-items-center'>
            <img src={'assets/layout/images/cdm_logo_full.svg'} alt={I18n.get("logo.alt")} style={{ width: '200px', height: '200px' }} />
        </div>,
        SignIn: {
            Header: () => {
                return (
                    <div className='flex justify-content-center align-items-center pt-5'>
                        <h1>{I18n.get('Sign in to your account')}</h1>
                    </div>
                );
            },
        }
    }

    return (
        <div style={{
            // The link variant's color IS the text on white, so it has to be dark enough itself
            // (#FFD500/#ccaa00 directly as text gave ~1.4:1 and ~2.3:1 - both well under the 4.5:1
            // WCAG 1.4.3 minimum for normal text). The primary button keeps the brand yellow as its
            // background but gets an explicit dark foreground color, since the default white button
            // text on that light a background was the same failure in the other direction.
            '--amplify-components-button-link-color': '#7a5d00',
            '--amplify-components-button-link-hover-color': '#4d3a00',
            '--amplify-components-button-link-active-color': '#4d3a00',
            '--amplify-components-button-primary-color': '#000000',
            '--amplify-components-button-primary-background-color': '#FFD500',
            '--amplify-components-button-primary-hover-background-color': '#ccaa00',
            '--amplify-components-button-primary-active-background-color': '#ccaa00'
        }}>
            <Authenticator
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh'
                }}
                components={components} hideSignUp loginMechanisms={['username']}>
                {props.content}
            </Authenticator>
        </div>
    );
}
